import AlertAccordion from "./AlertAccordion";
import AdvanceConfigAccordion from "./AdvanceConfigAccordion";
import StatisticsAccordion from "./StatisticsAccordion";
import {
  Accordion,
  AccordionDetail,
  AccordionHeader,
  AccordionItem,
} from "@vds/accordions";
import { Title } from "@vds/typography";
import { useSelector } from "react-redux";
import { Loader } from "@vds/loaders";

const AccordionDetails = ({
  state,
  imageUrl,
  isImageLoading,
  singleIncidentDetails,
  cvappid,
}) => {
  const imageSize = { width: 200, height: 128 };
  const cvapplist = useSelector((state) => state.cvAppReducer?.cvAppList) || [];
  return (
    <div
      data-testid="rule_accordionSection"
      className="eventInfo-accordion-section"
    >
      <div className="eventInfo-accordion">
      <Accordion>
        <AccordionItem>
          <AccordionHeader>
            <Title
              size="XSmall"
              className="eventInfo-accordion-title"
              data-testid="rule_accordionAlertDetailsTitleHeader"
            >
              Alert Details
            </Title>
          </AccordionHeader>
          <AccordionDetail>
            {isImageLoading ? (
              <Loader active={true} fullscreen={false} />
            ) : (
              <AlertAccordion
                state={state}
                imageUrl={imageUrl}
                isLoading={isImageLoading}
              />
            )}
          </AccordionDetail>
        </AccordionItem>

        {singleIncidentDetails && Array.isArray(singleIncidentDetails[0]) && singleIncidentDetails[0]?.map((i, index) => {
          if (
            i?.type === "SmartAlert"
          ) {
            return (
              <AccordionItem key={`smart-alert-${index}`}>
                <AccordionHeader>
                  <Title
                    size="XSmall"
                    className="eventInfo-accordion-title"
                    data-testid="rule_accordionAdvancedConfigTitleHeader"
                  >
                    Statistics
                  </Title>
                </AccordionHeader>
                <AccordionDetail>
                  <StatisticsAccordion newListTotal={i} />
                </AccordionDetail>
              </AccordionItem>
            );
          }else{
            return null;
          }
        })}

        {singleIncidentDetails && Array.isArray(singleIncidentDetails[0]) && singleIncidentDetails[0]?.map((i, index) => {
          const deployParameters = i?.deploymentConfig?.[0]?.config?.["deploy-parameters"] ?? {};
          const keysToSearch = ["colors", "objects"];
          let foundKeysToDisplay = [];
          if (Object.keys(deployParameters).length !== 0) {
            foundKeysToDisplay = Object.keys(deployParameters).filter(item => keysToSearch.includes(item));
          }
           if (i?.applicationId === "ParkingBayOccupancyEE" || i?.applicationId === "ParkingBayOccupancy") {
              return null;
          }
            
          const applicationIds = cvapplist.filter(m => m?.image).map(m => m.image);
          //["PeopleCountEE", "PeopleCountOA", "VehicleCountEE", "VehicleCountOA"]
          const foundApplicationIdToDisplay = applicationIds.includes(i?.applicationId);
           return (
            foundApplicationIdToDisplay &&
              <AccordionItem key={`adv-config-${i?.applicationId || index}`}>
                <AccordionHeader>
                  <Title
                    size="XSmall"
                    className="eventInfo-accordion-title"
                    data-testid="rule_accordionAdvancedConfigTitleHeader"
                  >
                    Advanced Configuration
                  </Title>
                </AccordionHeader>
                <AccordionDetail>
                    <AdvanceConfigAccordion
                      state={state}
                      newListTotal={i}
                      imageSize={imageSize}
                      imageUrl={imageUrl}
                      isLoading={isImageLoading}
                      cvappid={cvappid}
                    />
                </AccordionDetail>
              </AccordionItem>
            );
        })}
      </Accordion>
      </div>
    </div>
  );
};

export default AccordionDetails;
